// extracted by mini-css-extract-plugin
export var centerText = "_70-8";
export var container = "_70-0";
export var doughnutContainer = "_70-7";
export var legend = "_70-a";
export var legendItemColorDisplay = "_70-b";
export var legendItemLabel = "_70-d";
export var legendItemValue = "_70-c";
export var lg = "_70-5";
export var maxWidth = "_70-9";
export var md = "_70-4";
export var responsive = "_70-6";
export var sm = "_70-3";
export var xs = "_70-2";
export var xxs = "_70-1";